import authBg1 from "_assets/images/auth/slide-1.png";
import authBg2 from "_assets/images/auth/slide-5.png";
import authBg3 from "_assets/images/auth/slide-2.png";
import authBg4 from "_assets/images/auth/slide-3.png";
import authBg5 from "_assets/images/auth/slide-4.png";

export const authCarouselSlides = [
  {
    headline: "Trade Smarter.\nAnytime.",
    subtitle: "Access the Empire FX market directly from your phone.",
    background: authBg1,
  },
  {
    headline: "Real-Time\nMarket Access",
    subtitle: "Access the Empire FX market directly from your phone.",
    background: authBg2,
  },
  {
    headline: "Your Portfolio. Your\nControl.",
    subtitle: "Access the Empire FX market directly from your phone.",
    background: authBg3,
  },
  {
    headline: "Trade Smarter.\nAnytime.",
    subtitle: "Access the Empire FX market directly from your phone.",
    background: authBg4,
  },
  {
    headline: "Real-Time\nMarket Access",
    subtitle: "Access the Empire FX market directly from your phone.",
    background: authBg5,
  },
];
